import { Mesh, StandardMaterial, Texture ,Animation} from "@babylonjs/core";
import { Node } from "@babylonjs/core/node";
import { visibleInInspector,onKeyboardEvent,fromScene,onPointerEvent } from "./decorators";

/**
 * This represents a script that is attached to a node in the editor.
 * Available nodes are:
 *      - Meshes
 *      - Lights
 *      - Cameas
 *      - Transform nodes
 * 
 * You can extend the desired class according to the node type.
 * Example:
 *      export default class MyMesh extends Mesh {
 *          public onUpdate(): void {
 *              this.rotation.y += 0.04;
 *          }
 *      }
 * The function "onInitialize" is called immediately after the constructor is called.
 * The functions "onStart" and "onUpdate" are called automatically.
 */
export default class PosterBoard extends Mesh {
    @visibleInInspector("string","海报文件名")
    private _posterName:string = "";

    private _mat:StandardMaterial = null;
    /**
     * Override constructor.
     * @warn do not fill.
     */
    // @ts-ignore ignoring the super call as we don't want to re-init
    protected constructor() { }

    /**
     * Called on the node is being initialized.
     * This function is called immediatly after the constructor has been called.
     */
    public onInitialize(): void {
        // ...
    }

    /**
     * Called on the scene starts.
     */
    public onStart(): void {
        var scene = this.getScene();
        this._mat = new StandardMaterial("poster", scene);
        this._mat.diffuseTexture = new Texture("./scenes/_assets/Images/PosterBoards/120p/" + this._posterName, scene);
        //mat.diffuseTexture.hasAlpha = true;
        this._mat.backFaceCulling = true;
        this.material = this._mat;



        const frameRate = 10;

        const zoomInOut_x = new Animation("zoomInOut", "scaling.x", frameRate, 
            Animation.ANIMATIONTYPE_FLOAT, Animation.ANIMATIONLOOPMODE_CYCLE);
        const zoomInOut_y = new Animation("zoomInOut", "scaling.y", frameRate, 
            Animation.ANIMATIONTYPE_FLOAT, Animation.ANIMATIONLOOPMODE_CYCLE);

        const keyFrames_x = []; 
        keyFrames_x.push({
            frame: 0,
            value: this.scaling.x
        });
        keyFrames_x.push({
            frame: frameRate,
            value: this.scaling.x * 1.2
        });
        keyFrames_x.push({
            frame: 2 * frameRate,
            value: this.scaling.x
        });

        zoomInOut_x.setKeys(keyFrames_x);
        const keyFrames_y = []; 
        keyFrames_y.push({
            frame: 0,
            value: this.scaling.y
        });
        keyFrames_y.push({
            frame: frameRate,
            value: this.scaling.y * 1.2
        });
        keyFrames_y.push({
            frame: 2 * frameRate,
            value: this.scaling.y
        });
        zoomInOut_y.setKeys(keyFrames_y);

        this.animations.push(zoomInOut_x);
        this.animations.push(zoomInOut_y);

        //scene.beginAnimation(this, 0, 2 * frameRate, true);

    }

    public loadHightImage(){
        console.log("加载高清图");
        var scene = this.getScene();
        this._mat.diffuseTexture = new Texture("./scenes/_assets/Images/PosterBoards/1200p/" + this._posterName, scene);
        this._mat.diffuseTexture.hasAlpha = true;
        this._mat.backFaceCulling = true;
        this.material = this._mat;
    }

    /**
     * Called each frame.
     */
    public onUpdate(): void {
        // ...
    }

    /**
     * Called on the object has been disposed.
     * Object can be disposed manually or when the editor stops running the scene.
     */
    public onStop(): void {
        // ...
    }

    /**
     * Called on a message has been received and sent from a graph.
     * @param message defines the name of the message sent from the graph.
     * @param data defines the data sent in the message.
     * @param sender defines the reference to the graph class that sent the message.
     */
    public onMessage(name: string, data: any, sender: any): void {
        switch (name) {
            case "myMessage":
                // Do something...
                break;
        }
    }
}
